import { LoadManager, PageHeader, Styles } from '@/components'
import usePageTitle from '@/hooks/usePageTitle'
import React from 'react'
import useAxiosRequest from '@/hooks/useAxiosRequest'
import partnerLicensings from '@/services/api/settings/partnerLicensings'
import AddressCard from './components/AddressCard'
import PartnerDataCard from './components/PartnerDataCard'

function Profile({ title }) {
  usePageTitle({ title })
  const {
    data, loading, error, fetchData,
  } = useAxiosRequest(
    partnerLicensings.current,
  )

  return (
    <Styles.Container className="grid-xl">
      <PageHeader
        icon="fas fa-user-edit"
        title="Dados do parceiro/prefeitura"
        subtitle="Visualize e edite os dados do parceiro/prefeitura"
      />
      <LoadManager loading={loading} error={error}>
        {Boolean(data) && (
          <>
            <PartnerDataCard licensing={data.licensed} onUpdated={fetchData} />
            <AddressCard licensing={data} onUpdated={fetchData} />
          </>
        )}
      </LoadManager>
    </Styles.Container>
  )
}

export default Profile
